export enum ReferralVerificationReason {
  prescriberReferral = 'prescriber_referral',
  prescriberOfficeReferral = 'prescriber_office_referral',
  specialityReferral = 'speciality_referral',
  other = 'other',
}
